// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqTreadmillSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqTreadmillSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none">
      <path
        d="M5.12305 15.8095H23.1379V1.82422H21.7156C21.7156 1.82422 20.7044 1.82431 20.0564 1.82422C19.3453 1.82412 18.2784 5.11589 18.2784 5.11589"
        stroke="#444444"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21.9524 14.5471H5.3598C4.85328 14.5479 3.03473 14.5492 3.03473 14.5469C2.96764 14.5464 3.61176 15.017 3.61176 15.017M3.61176 15.017C3.61176 15.017 2.72287 14.0004 2.27813 15.0178M3.61176 15.017L2.27813 15.0178M2.32079 18.8856C2.79486 18.8856 4.0559 18.8862 3.61145 18.8862C3.16701 18.8862 2.32079 18.8856 2.32079 18.8856ZM2.32079 18.8856H19.6115C20.5369 18.8882 22.2189 18.8856 23.167 18.8856M2.32079 18.8856C2.32079 17.4987 2.19102 15.2178 2.27813 15.0178"
        stroke="#444444"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default EqTreadmillSVG;
